
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from '../../api';
import UpLoad from '../../components/LoansUpload';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
UpLoad,
XButton,
},
mounted() {
this.getInfo();
},
activated() {
},
watch: {



},
data() {
return {
formData: {
license: '',
regAmount: '',
regDate: '',
businessPaper: '',
},
imgArr: [],
emptyFlag: [],
};
},
computed: {
},
methods: {
getImgUrl(data) {
this.imgArr.push(data);
this.computEmptyNum();
},
deleImg(i) {
this.imgArr.splice(i, 1);
this.computEmptyNum();
},
computEmptyNum() {
const n = (this.imgArr.length + 1) % 4;
this.emptyFlag = [];
if (n !== 0) {
const num = 4 - n;
for (let i = 0; i < num; i++) {
this.emptyFlag.push(i);
}
}
},
save() {
const url = [];
this.imgArr.map((item) => {
url.push(item.url);
return item;
});
api.vega.company.saveCompanyImages({
urls: url.join(','),
}).then((res) => {
const code = res.data;
const _this = this;
if (code.code === 0 && code.sub_code === 0) {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
_this.$router.go(-1);
}
});
}
});
},
getInfo() {
api.vega.company.getCompanyImages({}).then((res) => {
const data = res.data.data;
this.imgArr = data;
this.computEmptyNum();
})
}
},
};
